import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {DceComponent, debounce} from "dce-engine";
import {findFragmentParent, Fragment} from "dce-fragments";
import Dce from "dce-engine/lib/decorators/Dce";
import choices from "choices.js/public/types/src/scripts/reducers/choices";
import Choices from "choices.js";
import {Choice} from "choices.js/src/scripts/interfaces/choice";

interface CheckboxShowProps {

}

/**
 * Pokazywanie odpowiedniego div;a na podstawie zaznaczenia
 */
@Dce("CheckboxShow")
export default class CheckboxShow extends DceComponent<CheckboxShowProps> {

    private parentFragment: Fragment;

    constructor(elem: DceHTMLElement, props: CheckboxShowProps) {
        super(elem, props);
        this.parentFragment = findFragmentParent(elem);

        elem.addEventListener('change', e => {
            this.updateDisplay();
        });

        this.updateDisplay();
    }

    private updateDisplay() {

        let check = (this.elem as unknown as HTMLInputElement);
        let id = check.id;

        if (check.checked) {
            this.parentFragment.updateDisplay(
                '*[data-check-show-id="' + id + '"]', 'block'
            );
        } else {
            this.parentFragment.updateDisplay(
                '*[data-check-show-id="' + id + '"]', 'none'
            );
        }

    }
}